import { UserPreference } from './user-preference'
import { UserPreferenceQuery } from './user-preference-query'
import { UserPreferenceMutation } from './user-preference-mutation'

export const entities = [UserPreference]
export const resolvers = [UserPreferenceQuery, UserPreferenceMutation]
export const subscribers = []
